import Router from 'vue-router';
import routes from './routes';
import locale from '../lang/locale';

export default () => {
    let router =  new Router({
        routes,
        base: '/' + locale.base,
        // mode: 'history',
        mode: 'hash',
        linkExactActiveClass: 'exact-active',
        linkActiveClass: 'active',
        scrollBehavior(to, from, savedPosition) {
            // 部分页面跳转的时候不需要回到顶部
            if (to.meta.name && from.meta.name && to.meta.name == from.meta.name) { 
                return;
            }
            if (savedPosition) {
                return savedPosition
            } else {
                return {
                    x: 0,
                    y: 0
                }
            }
        }
    })
    // router.beforeEach((to, from, next) => {
    //     // if(!cookies.get('yxj_ukey') || cookies.get('yxj_ukey') == ''){
    //     //     if (process.env.VUE_APP_MODE == 'production') { 
    //     //         auth();
    //     //     }
    //     // }
    //     // if (to.matched.some(record => record.meta.requiresAuth)) {
    //     //     if (!cookies.get('yxj_ubind') || cookies.get('yxj_ubind') == 0) {
    //     //         next({
    //     //             path: '/mine/login',
    //     //             query: { redirect: to.fullPath }
    //     //         })
    //     //     } else {
    //     //         next()
    //     //     }
    //     // } else {
    //         // next()
    //     // }
    //     if (lange.base != '') { 
    //         // next({ path: '/' + lange.base })
    //     } else {
    //         next()
    //     }
    // })
    return router
}